<template>
  <div class="yk-home-fill-wrapper">
    <el-form ref="formOption"
             class="yk-multiselect"
             label-width="100px"
             label-position="left">
      <el-form-item label="题目：">
        <div v-if="IsTitle">
          <Editor v-model="content" />
        </div>
        <div v-else
             class="yk-claer-style-margin">
          <span v-html="data.Content"
                class="yk-multiselect-question  yk-span-wrapper"></span>
        </div>
      </el-form-item>
      <!-- <el-form-item label="题目附件：" v-if="filesList.length > 0"> -->
      <el-form-item label="题目附件：">
          <div v-if="IsTitle">
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
          <div v-else>
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
      </el-form-item>
      <div v-if="isBook">
        <div v-if="IsSelects==0">
          <el-form-item label="答案：" class="an">
            <el-form-item label-width="30px"
                          v-for="(question,index) in CheckValues"
                          :key="index">
              <el-checkbox-group v-model="check">
                <el-checkbox :label="question.choice"
                             @change="addCheckValue"></el-checkbox>
                <el-input placeholder="请输入选项内容"></el-input>
                <i class="el-icon-close"
                   @click="closeChoice(index)"></i>
              </el-checkbox-group>
            </el-form-item>
          </el-form-item>
        </div>
        <!-- <div v-else-if="IsSelects > 0">
          <el-form-item label="答案：">
            <el-form-item label-width="30px"
                          v-for="(question,index) in questions"
                          :key="index+1">
              <span>{{index + 1}}.</span>
              <el-input placeholder="请输入选项内容"
                        v-model="questions[index]"
                        @change="doCheckValue"></el-input>
            </el-form-item>
          </el-form-item>
        </div> -->
      </div>
      <el-form-item label="答案："
                    v-show="IsAnswers && isBook">
        <el-form-item v-for="(question,index) in CheckValues"
                      :key="index">
          <span>{{index+1}}. </span><span v-html="question"></span>
        </el-form-item>
      </el-form-item>
      <el-form-item label="解析：" v-if="isBook">
        <div>
          <span v-if="data.Analysis==null">无</span>
          <span v-else v-html="data.Analysis"></span>
        </div>
      </el-form-item>
      <el-form-item label="解析附件：" v-if="isBook">
          <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
      </el-form-item>
    </el-form>
    <!-- <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="anaShow">
      <i class="el-icon-arrow-up"></i>
      <span>收起解析</span>
    </div>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="!anaShow">
      <i class="el-icon-arrow-down"></i>
      <span>查看解析</span>
    </div> -->
  </div>
</template>

<script>
// import Vue from 'vue';
// import QuestionFile from 'components/AliyunOSS/QuestionFileNew.vue';
import QuestionFile from '../AliyunOSS/QuestionFileNew.vue';
export default {
  name: 'fillInTheBlanks',
  components: {
    QuestionFile
  },
  props: {
    isBook:{
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: false
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  created() {
    this.cont = this.data;
    this.questions = this.data.Selects;
    this.CheckValues = this.data.Answers;
    this.content = this.data.Analysis;
    if (this.data.Answers) {
      this.questions = this.data.Answers;
    }
    // 题目附件
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  },
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      anaShow: true,
      showThisAnswer: true,
      cont: [],
      content: '请输入内容',
      formOption: {
        choice: null
      },
      questions: [],
      a: 1,
      CheckValues: [],
      check: [],
      alphabet: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ]
    };
  },
  watch: {},
  methods: {
    upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 添加选项
    addChoice: function() {
      var n = this.questions.length;
      var str = { id: n, contrary: false, choice: this.alphabet[n] };
      this.questions.push(str);
      this.CheckValues.push(null);
    },
    // 删除选项
    closeChoice: function(index) {
      for (var i = 0; i <= index; i++) {
        this.questions[i].choice = this.alphabet[i];
      }
      this.questions.splice(index, 1);
      this.CheckValues = this.check;
    },
    // 添加正确答案
    addCheckValue: function() {
      this.CheckValues = this.check;
    },
    // 做作业是选择答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.cont.Id,
        Answers: this.questions
      });
    }
  }
};
</script>

<style lang="scss">
// @import '~theme/page/components/variables.scss';
@import '../../theme/page/components/variables.scss';
.yk-home-fill-wrapper {
  padding: 0 20px;
  position: relative;
  .el-form-item {
    margin-bottom: 20px;
    .el-form-item__label {
      color: black;
    }
    .el-form-item__content {
      font-size: 16px;
      color: black;
    }
  }
  .yk-multiselect {
    .el-form-item__label,
    .el-form-item__content {
      color: black;
      font-size: 16px;
    }
    .yk-multiselect-question {
      p {
        margin: 0;
        padding: 0;
      }
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-input {
      width: 85%;
      margin-left: 15px;
    }
    i.el-icon-close {
      font-size: 15px;
      margin-left: 10px;
    }
    
    // .el-col .yk-addChoice {
    //   margin-left: 70px;
    //   color: #606266;
    // }
  }
  .yk-mm-up-down-wrapper {
    position: absolute;
    width: 240px;
    height: 30px;
    background: #f5f5f5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    bottom: -50px;
    left: 50%;
    margin-left: -120px;
    border-radius: 0 0 30px 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>

